import { styled } from '@mui/system'

export const CategoryBarContainer = styled('div')`
    display: flex;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
`
